<script>
    import SubPageHeader from '../components/SubPageHeader.svelte'
    import SubNav from '../components/SubNav.svelte'
	import SubNavButton from '../components/SubNavButton.svelte'
	import NewsArticleBox from '../components/NewsArticleBox.svelte'
    
    import { translations, current_lang, news_api_storage, news_cats_api_storage } from '../stores.js';

	import {replace} from 'svelte-spa-router'

	export let params = {cat};

	let current_cat;
	
	let all_news;
	let news;

	function get_all_current_language_news(){
		if($current_lang == "FI"){
			return all_news.fi;
		}
		if($current_lang == "EN"){
			return all_news.en;
		}
		return null;
	}

	function get_category_filtered_news(cat){
		current_cat = cat;
		let cln = get_all_current_language_news();
		return cln.filter(x => x.catid === current_cat);
	}

    news_api_storage.subscribe(value => {
		all_news = value;
		if(all_news != null){
			news = get_all_current_language_news();
			if(params.cat != null){
				news = get_category_filtered_news(params.cat);
			}
		}
		//console.log(all_news)
    });

	let news_cats;
    news_cats_api_storage.subscribe(value => {
        news_cats = JSON.parse(value);
    });
	
	function show_news_category(cat){
		if(cat == "all"){
			current_cat = null;
			replace('/news/');
			news = get_all_current_language_news();
		}else{
			replace('/news/'+cat);
			news = get_category_filtered_news(cat);
		}
	}
</script>
<SubPageHeader page_title={$translations["NEWS"][$current_lang]} is_section_main_page={true}/>
<!-- {#if news_cats != null && $current_lang != "EN"}
	<SubNav>
			<SubNavButton on:click={() => show_news_category("all")} text={"Kaikki aiheet"} active={!current_cat}/>
			{#each news_cats as cat}
				{#if cat.title == "Ajankohtaista"}
					<SubNavButton on:click={() => show_news_category(cat.id)} text={"Uutiset"} active={current_cat == cat.id}/>
				{/if}
				{#if cat.title == "Kohti tapahtumaa"}
					<SubNavButton on:click={() => show_news_category(cat.id)} text={"Muut artikkelit"} active={current_cat == cat.id}/>
				{/if}
			{/each}
	</SubNav>
{/if} -->
<div class="content-container full">
	{#if news != null}
		{#each news as article}
			<NewsArticleBox {article} />
		{/each}
	{:else}
		<div class="content-container">
			{#if $current_lang == "FI"}
				<p>Sisällön lataaminen ei onnistunut. Ongelma voi johtua siitä, että laitteesi ei saa yhteyttä verkkoon. Jos näet tämän virheilmoituksen vielä yhteyden palauduttua, voit koittaa sulkea sovelluksen ja käynnistää sen uudelleen.</p>
			{:else}
				<p>Could not load content. Your device may be offline. If your connection has been restored and you still see this error, you can try restarting the app.</p>
			{/if}
		</div>
	{/if}
</div>
